import PropTypes from 'prop-types';
import React from 'react';

import connectToStores from 'fluxible-addons-react/connectToStores';
import DesignCommentsStore from '../stores/DesignCommentsStore';

const InjectedSidebarComponent = ({ renderSidebar, ...props }, context) => {
    return renderSidebar(props);
};

InjectedSidebarComponent.contextTypes = {
    getStore: PropTypes.func,
};

export const ConnectedSidebarComponent = connectToStores(
    InjectedSidebarComponent,
    [DesignCommentsStore],
    (context, props) => {
        return {
            isLoadingComments: context.getStore(DesignCommentsStore).isLoadingComments,
            isLoaded: context.getStore(DesignCommentsStore).isLoaded,
            comments: context.getStore(DesignCommentsStore).comments,
            selectedComment: context.getStore(DesignCommentsStore).selectedComment,
            selectedCommentStatus: context.getStore(DesignCommentsStore).selectedCommentStatus,
            selectedCommentEditingLocation: context.getStore(DesignCommentsStore)
                .selectedCommentEditingLocation,
        };
    }
);



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/DesignDetailsSidebar.jsx